import { FC } from "react"
import { Outlet } from "react-router-dom"
import logo from "/logo-transparent.png"
import { Toaster } from "@/components/ui/sonner"

const AuthLayout: FC = () => {
  return (
    <main className="w-full h-screen flex flex-col md:flex-row overflow-hidden">
      <div className="hidden md:flex flex-1 h-screen  items-center justify-center border-r border-border overflow-hidden">
        <div className="flex flex-col items-center justify-center space-y-8 px-12 max-w-lg">
          <img
            src={logo}
            alt="logo"
            className="w-auto h-auto max-w-md max-h-md object-contain"
          />
          <div className="text-center space-y-4">
            <p className="text-base text-muted-foreground leading-relaxed">
              Streamline your business operations and manage everything in one place.
            </p>
          </div>
        </div>
      </div>
      <div className="flex-1 w-full h-screen overflow-y-auto flex items-center justify-center">
        <div className="w-full max-w-lg mx-auto flex flex-col justify-center items-center py-10 px-4 pr-1">
          <Outlet />
        </div>
      </div>
      <Toaster />
    </main>
  )
}

export default AuthLayout
